import { createContext, useReducer, useEffect } from 'react'
import { handleTokenError, isTokenError } from '../whitaijiFrontendLibrary/auth/utils'
import { useStateContext } from './StateContext'

export const AuthContext = createContext()

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { user: action.payload }
    case 'LOGOUT':
      return { user: null }
    default:
      return state
  }
}

export const AuthContextProvider = ({ children }) => {
  // Use REACT_APP_ prefix for environment variables in React
  const apiUrl = (process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : process.env.REACT_APP_BACKEND_URL);

  // Log API URL configuration in development for debugging
  if (process.env.NODE_ENV === 'development') {
    //process.env.NODE_ENV === "development" && console.log('API URL:', apiUrl);
  }
  const [state, dispatch] = useReducer(authReducer, { 
    user: null
  })

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))

    if (user) {
      // Just restore the user from localStorage without validation
      dispatch({ type: 'LOGIN', payload: user });
    }
  }, [dispatch])

  // Function to validate token - only called on protected routes
  const validateToken = async () => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (!user) return false;

    if (!apiUrl) {
      process.env.NODE_ENV === "development" && console.error('API URL is not configured. Token validation failed.');
      return false;
    }

    try {
      const response = await fetch(`${apiUrl}/user/validate-token`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });

      if (!response.ok) {
        throw new Error('Token validation failed');
      }

      return true;
    } catch (error) {
      if (isTokenError(error)) {
        handleTokenError(error, dispatch);
      }
      return false;
    }
  }

  //process.env.NODE_ENV === "development" && console.log('AuthContext state:', state)
  
  return (
    <AuthContext.Provider value={{ ...state, dispatch, validateToken }}>
      { children }
    </AuthContext.Provider>
  )

}
